import polling from "@/helpers/polling";

// Busca o histórico do intervalo selecionado sem renderizar nada, para a mesma fonte servir às duas visões da tela
export default {
    name: "HistorySource",

    mixins: [polling()],

    props: {
        // Datas no formato YYYY-MM-DD
        dateFrom: { type: String, required: true },
        dateTo: { type: String, required: true },
    },

    created() {
        this.$emit("state", this.refresh);
    },

    methods: {
        fetch() {
            const dates = `dateFrom=${this.dateFrom}&dateTo=${this.dateTo}`;
            const requestedAt = Date.now();
            return this.$http.get(`api/v2/charge-history-dashboard?${dates}`, { continuous: true }).then((result) => {
                // Descarta a resposta se o intervalo mudou durante a requisição, o watch já pediu uma nova
                if (dates == `dateFrom=${this.dateFrom}&dateTo=${this.dateTo}`) this.$emit("update", { history: result || [], requestedAt });
            });
        },
    },

    watch: {
        dateFrom() {
            this.refreshNow();
        },
        dateTo() {
            this.refreshNow();
        },
    },

    render() {
        return null;
    },
};
